import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { AlertTriangle, X, CreditCard, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';

/**
 * Banner que aparece en el panel del admin cuando su empresa tiene desviación
 * de asientos con respecto al plan contratado. Se oculta si no aplica o si el
 * admin lo cierra en la sesión actual.
 */
export default function DesviacionBanner() {
  const [d, setD] = useState(null);
  const [cerrado, setCerrado] = useState(false);
  const [pagando, setPagando] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get('/admin/desviacion-actual')
      .then(r => { if (!cancelled && r.data?.aplica) setD(r.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!d || cerrado) return null;
  const positiva = d.delta > 0;

  const pagarConTarjeta = async () => {
    setPagando(true);
    try {
      const r = await api.post('/admin/desviacion-pagar-tarjeta', {});
      if (r.data?.checkout_url) {
        window.location.href = r.data.checkout_url;
      } else {
        toast.error('No se pudo generar el enlace de pago');
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error al iniciar el pago');
      setPagando(false);
    }
  };

  return (
    <div className={`${positiva ? 'bg-amber-50 border-amber-300 text-amber-900' : 'bg-blue-50 border-blue-300 text-blue-900'} border-b`} data-testid="desviacion-banner">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <AlertTriangle className={`h-5 w-5 shrink-0 ${positiva ? 'text-amber-600' : 'text-blue-600'}`} />
        <div className="flex-1 text-sm">
          {positiva ? (
            <>
              <b>Tu plan tiene {d.delta} usuario(s) por encima del contratado</b> ({d.activos}/{d.contratados}).
              Regularización pendiente: <b>{(d.importe_pendiente || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</b> (IVA incluido).
            </>
          ) : (
            <>
              Actualmente tienes {d.activos} usuarios activos, {Math.abs(d.delta)} por debajo del plan contratado ({d.contratados}).
              Puedes ajustar tu plan o aplicar el crédito en la próxima renovación.
            </>
          )}
        </div>
        {positiva && (
          <Button size="sm" onClick={pagarConTarjeta} disabled={pagando} className="bg-amber-600 hover:bg-amber-700 text-white h-8" data-testid="desviacion-pagar">
            {pagando ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <CreditCard className="h-3.5 w-3.5 mr-1" />}
            Regularizar con tarjeta
          </Button>
        )}
        <Button variant="ghost" size="icon" className="h-7 w-7" onClick={() => setCerrado(true)} data-testid="desviacion-cerrar">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
